import { JudgementStatus } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getJudgementStatus: (
  fetchContext: FetchContext,
  nominationId: number,
  userId: number,
  countryId?: number,
  accessToken?: string,
) => Promise<JudgementStatus> = (fetchContext, nominationId, userId, countryId, accessToken) => {
  const countryPath = countryId === undefined ? '' : `/country/${countryId}`;

  return fetch(`${fetchContext.baseUrl}/api/staff/nominations/${nominationId}/judges/${userId}${countryPath}/judgement-status`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<JudgementStatus>(fetchContext.errorStore, response, 'get judgement status'));
};
